import React from 'react';
import { Link } from 'react-router-dom';
import { usePremium } from '@/context/PremiumContext';

export default function DestinsAvailabilityGate({ children }) {
  const { catalog, loading, error, refresh } = usePremium();
  if (loading) return <div role="status" className="p-8 text-center text-slate-400">Vérification de la disponibilité…</div>;
  if (error) return <div role="alert" className="p-8 text-center text-slate-300">Impossible de vérifier la disponibilité. <button onClick={refresh} className="font-bold underline">Réessayer</button></div>;
  if (catalog?.availability?.destins === true) return children;
  return <section className="mx-auto max-w-xl px-6 py-20 text-center" data-testid="destins-paused">
    <p className="text-xs font-bold uppercase tracking-widest text-violet-300">DayOne FC</p>
    <h1 className="mt-4 font-head text-3xl font-bold">Destins est en pause</h1>
    <p className="mt-4 leading-relaxed text-slate-300">Tes chapitres, tes albums et tes souvenirs sont conservés. Retrouve le conseil et ton parcours dans la gestion du club.</p>
    <Link to="/gestion-club?onglet=carriere" className="mt-7 inline-flex rounded-xl bg-violet-300 px-5 py-3 font-semibold text-slate-950">Ouvrir ma carrière</Link>
  </section>;
}
